import React, { useEffect, useState } from 'react';
import { Spin, Alert, Card, Button } from 'antd';
import Layout from '../../components/Layout';
import AntTable from '../../components/CustomTable/AntTable';
import { customBaseUrl, httpPost } from '../../store/http';
import { NotificationManager } from 'react-notifications';

const AllReferralCustomers = () => {
    const [referralCustomers, setReferralCustomers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const fetchAllReferralCustomers = async (page = 1, pageSize = 10) => {
        setLoading(true);
        try {
            const payload = {
                pageNo: page - 1,
                pageSize: pageSize,
            };
            const res = await httpPost(`${customBaseUrl.referralUrl}/api/v1/admin/fetchAllReferralUsers`, payload);
            if (res.data && res.data.content) {
                setReferralCustomers(res.data.content);
                setPagination({
                    current: res.data.pageNo + 1,
                    pageSize: res.data.pageSize,
                    total: res.data.totalElements,
                });
            } else {
                setError(res?.message || 'Failed to fetch referral customers.');
            }
        } catch (err) {
            setError('An error occurred while fetching referral customers.');
            console.error(err);
            NotificationManager.error('An error occurred while fetching referral customers.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllReferralCustomers(pagination.current, pagination.pageSize);
    }, []);

    const handleTableChange = (pagination) => {
        fetchAllReferralCustomers(pagination.current, pagination.pageSize);
    };

    const columns = [
        { title: 'ID', dataIndex: 'id', key: 'id' },
        { title: 'Email', dataIndex: 'email', key: 'email' },
        { title: 'Phone Number', dataIndex: 'phoneNumber', key: 'phoneNumber' },
        { title: 'Referral Code', dataIndex: 'referralCode', key: 'referralCode' },
        { title: 'Reference Code', dataIndex: 'referenceCode', key: 'referenceCode' },
        { title: 'Organization Name', dataIndex: 'organizationName', key: 'organizationName' },
        { title: 'Corporate', dataIndex: 'corporate', key: 'corporate', render: (text) => (text ? 'Yes' : 'No') },
        { title: 'Created At', dataIndex: 'createdAt', key: 'createdAt' },
    ];

    return (
        <>
            <Card title="All Referral Customers">
                {loading ? (
                    <Spin tip="Loading referral customers..." />
                ) : error ? (
                    <Alert message="Error" description={error} type="error" showIcon />
                ) : (
                    <AntTable
                        pagination={pagination}
                        users={referralCustomers}
                        loading={loading}
                        handleGetNext={handleTableChange}
                        columns={columns}
                    />
                )}
            </Card>
        </>
    );
};

export default AllReferralCustomers;
